import React, { useContext } from 'react';

import EventTotalsContext from '@totem/components/services/threats/totals/EventTotalsContext';
import TotalsContainer from '@totem/components/services/threats/totals/TotalsContainer';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';

const ThreatManagementSection = () => {
  const { data } = useContext(EventTotalsContext);
  const hasThreatManagement =
    typeof data !== 'undefined' &&
    data !== null &&
    typeof data.threatManagementLast30Days !== 'undefined' &&
    data.threatManagementLast30Days !== null;
  const showSection = hasThreatManagement;

  return (
    <>
      {showSection && (
        <IBCard title={'Threat Management - Last 30 days'} isCovered>
          <TotalsContainer />
        </IBCard>
      )}
    </>
  );
};

export default ThreatManagementSection;
